// export const  post_id = '9263'
// export const  base_url="https://b.coderworld.xyz"

export function getPostId(){
    let href = window.location.href;
    let hrefArray = href.split("/");
    let postArray= hrefArray[hrefArray.length-1].split(".");
    let post_id = postArray[0];
    console.log(post_id);
    return post_id;
}


export function base_url(){
    const hostname = window.location.hostname;
    const base_url = "https://" + hostname;
    return base_url
}